import {FormConfig} from '../../../models/form-config';
import {AgreementModel} from '../../../../core/models/agreement.model';
import {FieldConfig} from '../../../models/field-config';
import {FieldType} from '../../../models/field-type';
import {AgreementsService} from '../../../services/agreements.service';

export class CalculationAgreementsSectionConfig {

    constructor(private agreementsService: AgreementsService,
                private agreementControlKeyPrefix: string) {
    }

    createFormConfig(agreements: AgreementModel[]): FormConfig {
        return {
            formKey: 'CALCULATION_AGREEMENTS_SECTION',
            fieldsConfig: agreements ? agreements.map(agreement => this.createAgreementConfig(agreement)) : []
        }
    }

    private createAgreementConfig(agreement: AgreementModel): FieldConfig {
        const agreementShortValue = this.agreementsService.getAgreementValue(agreement).shortValue;
        const agreementValue = agreementShortValue ? agreementShortValue : this.agreementsService.getAgreementValue(agreement).value;
        return {
            fieldKey: `${this.agreementControlKeyPrefix}_${agreement.code}`,
            fieldsDataFormat: 'objectArray',
            captionAsHTML: agreement.details.required ? `${this.agreementsService.REQUIRED_SYMBOL} ${agreementValue}` : agreementValue,
            type: FieldType.Checkbox,
            predefined: {
                isPredefined: false,
                additionalInfo: 'This is additional information email'
            },
            validators: agreement.details.required ? ['requiredTrue'] : [],
            beanConfig: {
                propertyName: 'agreements',
                keyPropertyName: 'code',
            },
            checkboxConfig: {
                readonly: false,
                expand: this.getCheckboxConfigExpand(agreement),
                mappingConfig: {
                    propertyName: 'selectedAnswer',
                    valuesMapping: this.agreementsService.getValuesMapping(agreement)
                }
            },
        };
    }

    private getCheckboxConfigExpand(agreement: AgreementModel): any {
        if (!!this.agreementsService.getAgreementValue(agreement).shortValue) {
            const expandText = this.agreementsService.getAgreementValue(agreement).value;
            return {
                expandedLabel: 'expand',
                collapsedLabel: 'collapse',
                expandText: agreement.details.required ? `${this.agreementsService.REQUIRED_SYMBOL} ${expandText}` : expandText,
                inline: true
            };
        }
        return null;
    }
}
